import React from "react";
import { TabDocumentacionArchivosCargados } from "../components/TabDocumentacion/TabDocumentacionArchivosCargados";
import { TabDocumentacionVisitas } from "../components/TabDocumentacion/TabDocumentacionVisitas";
import { TabDocumentacionRI } from "../components/TabDocumentacion/TabDocumentacionRI";
import '../gestionAsistencialCreationContent.scss';

export const TabDocumentacion = ({ evaluacionSelected, idDelegacion }) => {

    return (
        <>
            <TabDocumentacionArchivosCargados
                evaluacionSelected={evaluacionSelected}
                idDelegacion={idDelegacion}
            />
            <TabDocumentacionVisitas
                evaluacionSelected={evaluacionSelected}
                idDelegacion={idDelegacion}
            />
            <TabDocumentacionRI
                evaluacionSelected={evaluacionSelected}
                idDelegacion={idDelegacion}
            />
        </>
    );
};